import { useCallback } from 'react';
import { CitationModalContent } from '../CitationModalContent';
export function transformInlineCitations(contentText, sources) {
  return contentText.replace(
  // regexr.com/8gell
  /<!-- <cite>(([a-f\d-]{36},?)+)<\/cite> -->/g, (match, citationIds) => {
    const citationsLinks = citationIds.split(',').map(id => {
      const sourceIndex = sources.findIndex(source => source.citationId === id);
      const citedSource = sources[sourceIndex];
      if (citedSource) {
        return `<a title="${sources[sourceIndex].title}" href="tag:${sources[sourceIndex].citationId}">${sourceIndex + 1}</a>`;
      }
      return id;
    }).join('');
    return `<cite>${citationsLinks}</cite>`;
  });
}
const inlineCitationLinkClickHandler = ({
  e,
  browserWindowHeight,
  navigateToKnowledgeBaseArticle,
  openModal,
  sources
}) => {
  e.preventDefault();
  const href = e.target.href;
  const citationId = href.split('tag:')[1];
  const sourceData = sources.find(source => source.citationId === citationId);
  if (!sourceData) {
    return;
  }
  openModal(CitationModalContent(sourceData, browserWindowHeight, navigateToKnowledgeBaseArticle));
};
export function useInlineCitations({
  browserWindowHeight,
  navigateToKnowledgeBaseArticle,
  openModal,
  sources
}) {
  return useCallback(() => {
    const handleInlineCitationLinkClick = e => {
      inlineCitationLinkClickHandler({
        e,
        sources,
        navigateToKnowledgeBaseArticle,
        browserWindowHeight,
        openModal
      });
    };
    const inlineCitationLinks = document.querySelectorAll('[data-test-use="agent"] a[href^="tag:"]');
    Array.from(inlineCitationLinks).filter(link => /^tag:[a-f\d-]{36}$/.test(link.href)).forEach(link => {
      link.removeEventListener('click', handleInlineCitationLinkClick);
      link.addEventListener('click', handleInlineCitationLinkClick);
    });
  }, [browserWindowHeight, navigateToKnowledgeBaseArticle, openModal, sources]);
}